module.exports = __webpack_public_path__ + "img/chest.b8680a4f.svg";